module.exports = __webpack_public_path__ + "static/media/finearts.5c2e1fce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/finearts.svg
// module id = 3066
// module chunks = 0